import styled from "styled-components";

import { colorsPalettes, $robotoFontFamily } from "@similarweb/styles";
import { ScrollArea, Autocomplete } from "@similarweb/ui-components";

import type { IAutocompleteStyledProps } from "pro-features/components/AutocompleteWebsites/types";

export const PlaceholderText = styled.span`
    color: ${colorsPalettes.carbon["300"]};
    font-family: ${$robotoFontFamily};
    font-size: 14px;
    margin-left: 36px;
`;

export const BoldPlaceholderText = styled.span`
    font-weight: 500;
`;

export const AutocompleteStyled = styled(Autocomplete)<IAutocompleteStyledProps>`
    width: 100%;
`;

export const ScrollAreaWrap = ({ children, ...rest }: FixmeType) => {
    return (
        <ScrollArea
            style={{ maxHeight: 400, minHeight: 0 }}
            verticalScrollbarStyle={{ borderRadius: 5 }}
            horizontal={false}
            smoothScrolling={true}
            minScrollSize={48}
            {...rest}
        >
            {children}
        </ScrollArea>
    );
};
